export const baseUrl = "https://api-school.shmsedu.in/api/";